import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { FaInstagram, FaFacebook } from 'react-icons/fa';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerBrand}>
          <h3>2Nice </h3>
          <p>Your one-stop shop for perfectly tailored petite clothing.</p>
        </div>
        
        <div className={styles.footerLinks}>
          <div className={styles.linkGroup}>
            <h4>Social Media</h4>
            <ul>
              <li>
                <a href="https://www.instagram.com/2nice_turkey?igsh=Y2VlbmNsb2hwcnZp" target="_blank" rel="noopener noreferrer">
                  <FaInstagram style={{ verticalAlign: 'middle', marginRight: 6 }} /> Instagram
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/share/1EPkJxfhUB/" target="_blank" rel="noopener noreferrer">
                  <FaFacebook style={{ verticalAlign: 'middle', marginRight: 6 }} /> Facebook
                </a>
              </li>
            </ul>
          </div>
          
          <div className={styles.linkGroup}>
            <h4>Navigation</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/shop">Shop</Link></li>
            </ul>
          </div>
          
          
        </div>
      </div>
      
      <div className={styles.footerBottom}>
        <p>© 2024 2Ncice. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer; 